import RequestPage from '@/components/RequestPage';
import VisitorLayout from '@/layouts/visitor-layout';
import { requestShow } from '@/routes';
import { Head } from '@inertiajs/react';

export default function Request({
    response,
}: {
    response: {
        menuItems: App.Data.MenuItemData[];
        categories: string[];
        customer?: App.Data.CustomerData | null;
    };
}) {
    return (
        <VisitorLayout>
            <Head>
                <title>Request</title>
                <meta name="description" content="Request a menu item" />
                <meta name="image" content={import.meta.env.VITE_APP_URL + '/logo.jpg'} />
                <meta name="url" content={requestShow().url} />
                <meta name="canonical_url" content={requestShow().url} />
                <meta name="type" content="website" />
                <meta name="author" content="Let\'s Cafe" />
                <meta name="robots" content="index, follow" />
                <meta name="published_time" content={new Date().toISOString()} />
                <meta name="modified_time" content={new Date().toISOString()} />
                <meta name="site_name" content="Let\'s Cafe" />
                <meta name="section" content="Request" />
                <meta name="tags" content="request, menu, items" />
                <meta name="twitter_username" content="Let\'s Cafe" />
                <meta name="og:title" content="Request" />
                <meta name="og:description" content="Request a menu item" />
                <meta name="og:image" content={import.meta.env.VITE_APP_URL + '/logo.jpg'} />
                <meta name="og:url" content={requestShow().url} />
                <meta name="og:type" content="website" />
                <meta name="og:site_name" content="Let\'s Cafe" />
                <meta name="og:section" content="Request" />
                <meta name="og:tags" content="request, menu, items" />
                <meta name="og:twitter_username" content="Let\'s Cafe" />
                <meta name="og:published_time" content={new Date().toISOString()} />
                <meta name="og:modified_time" content={new Date().toISOString()} />
                <meta name="og:locale" content="en" />
                <meta name="og:canonical_url" content={requestShow().url} />
                <meta name="og:alternates" content={requestShow().url} />
                <meta name="og:schema" content={requestShow().url} />
            </Head>
            <RequestPage
                menuItems={response.menuItems}
                categories={response.categories}
                customer={response.customer}
            />
        </VisitorLayout>
    );
}
